import {toAbsoluteUrl} from "@khan/urls";

const GLOBAL_FREE_TEACHER_TOOLS_TERMS_URL_V2 = toAbsoluteUrl(
    "/about/docs/grassroots-khanmigo-teacher-tools-terms",
);

// Returns a URL to the current terms of service for teacher tools.
export default function useFreeForTeachersTerms(): string {
    return GLOBAL_FREE_TEACHER_TOOLS_TERMS_URL_V2;
}
